import {createEvent, createStore} from 'effector';

let alreadySet = false;

const $demo = createStore(false);

const init = {
    setDemo: createEvent(),
};

$demo.on(init.setDemo, (state, result) => {
    const newState = alreadySet ? state : result;
    alreadySet = true;
    return newState;
});

const demo = {
    $demo,
    init
};

export default demo;
